// @flow

export const lastAction = (state: Object, action: Object): any => {
  return action.type;
};
